import { createComponent } from '@mtfe/sweet';
import { lazyLoadImg, common } from '@mtfe/sweet-utils';

import tpl from './dom.html';
import style from './style.less';
const { DEFAULT_DATA_SRC } = lazyLoadImg;

const RedPacketPoiBaseInfo = (props = {}) => {
    try {
        const {
            poiInfo,
            onPoiInfoClick,
            isLazyLoadImg = true,
            itemIndex,
            redBagInfo,
            poiList,
            recallBizId,
        } = props;
        const data = {
            poiInfo,
            DEFAULT_DATA_SRC,
            isLazyLoadImg,
            itemIndex,
        };
        const events = {
            onPoiInfoClick: () => {
                onPoiInfoClick &&
                    onPoiInfoClick(poiInfo, redBagInfo, poiList, recallBizId);
            },
        };
        const component = createComponent(tpl, { data, style }, events);
        return component;
    } catch (error) {
        console.error(error);
        return '';
    }
};

export default RedPacketPoiBaseInfo;
